export default "__VITE_ASSET__DxNGpmhr__"